var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisibility = function SvgVisibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C7.45455 5 3.57273 7.69533 2 11.5C3.57273 15.3047 7.45455 18 12 18C16.5455 18 20.4273 15.3047 22 11.5C20.4273 7.69533 16.5455 5 12 5ZM12 15.8333C9.49091 15.8333 7.45455 13.892 7.45455 11.5C7.45455 9.108 9.49091 7.16667 12 7.16667C14.5091 7.16667 16.5455 9.108 16.5455 11.5C16.5455 13.892 14.5091 15.8333 12 15.8333ZM12 8.9C10.4909 8.9 9.27273 10.0613 9.27273 11.5C9.27273 12.9387 10.4909 14.1 12 14.1C13.5091 14.1 14.7273 12.9387 14.7273 11.5C14.7273 10.0613 13.5091 8.9 12 8.9Z",
    fill: "#121232"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisibility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visibility.f8084b56.svg";
export { ForwardRef as ReactComponent };